import {BaseWrapper} from '../../../allkey/framework/parameters/BaseWrapper';
import {BasicScenario} from '../../../allkey/framework/parameters/BasicScenario';
import {Measure} from '../message/Measure';
import {MeasureCriteria} from './MeasureCriteria';

export class MeasureWrapper extends BaseWrapper<Measure, MeasureCriteria, BasicScenario>  {}

